export default "__VITE_ASSET__C4Ia71zf__"